import { render, staticRenderFns } from "./clientcard.vue?vue&type=template&id=e378ef7e&lang=true&"
import script from "./clientcard.vue?vue&type=script&lang=js&"
export * from "./clientcard.vue?vue&type=script&lang=js&"
import style0 from "./clientcard.vue?vue&type=style&index=0&id=e378ef7e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports